import { useMemo } from 'react';

import isNotEmptyArray from '@travel/ui/utils/arrays';

import type { Price } from 'ProviderList-Types';
import { shouldDisplayDiscountPrice } from 'utils/salesPromotion';

export function usePrice(price: Price | undefined, isDirectContract: boolean) {
  return useMemo(() => {
    if (price) {
      const basePrice = price.base;
      let totalPrice = isDirectContract ? price.base : price.total;
      let unitPrice = price.unitRate;
      let priceWithoutDiscount = null;
      const isConsumptionTaxIncluded = price?.isConsumptionTaxIncluded;

      // checking the sales promotion
      if (
        isNotEmptyArray(price.salesPromotions) &&
        shouldDisplayDiscountPrice(price.salesPromotions)
      ) {
        if (isDirectContract) {
          totalPrice = price.total;
        } else {
          if (price.discountedUnitRate != null) {
            unitPrice = price.discountedUnitRate;
          }
          priceWithoutDiscount = price.unitRate;
          totalPrice = price.total;
        }
      }
      return { unitPrice, totalPrice, priceWithoutDiscount, isConsumptionTaxIncluded, basePrice };
    } else {
      return {
        unitPrice: 0,
        totalPrice: 0,
        priceWithoutDiscount: 0,
        isConsumptionTaxIncluded: 0,
        basePrice: 0,
      };
    }
  }, [price, isDirectContract]);
}
